import { Button, Popover, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import RenderSvg from "../../../../../../../layout/components/icons/RenderSvg";
import RatingColumnComponent from "../../ratingColumnComponent";
import "./styles.scss";
import { useHistory, useLocation } from "react-router-dom";
import { getBreadCrumbSession } from "../../../../../../../core/helpers/localStorage/breadCrumbSession";
import { SessionStorage } from "../../../../../../../core/helpers/localStorage/sessionStorage";
import { SessionVariables } from "../../../../../../../core/constants/SessionVariables";
import isEmpty from "../../../../../../../core/helpers/isEmpty";
import AddRemoveWatchListModal from "../addRemoveWatchList";
import localize from "../../../../../../../core/utils/translation-files";
import { TrackedItemsVariables } from "../../../../../../../core/constants/TrackedItemsConstants";
const { getKey, setKey } = SessionStorage;
const { BREADCRUMB } = SessionVariables;
const CurrentFinancialRatingBox = ({ record, financialData, navigateCallBack = undefined, }) => {
    const [showFinancialRating, setShowFinancialRating] = useState(false);
    const [filteredFinancialData, setFilteredFinancialData] = useState([]);
    const [watchListModalData, setWatchListModalData] = useState(undefined);
    const handleToggleModalVisibility = (event, trackedItemId = undefined) => {
        event.preventDefault();
        event.stopPropagation();
        setWatchListModalData(trackedItemId);
    };
    const history = useHistory();
    useEffect(() => {
        // if (record) {
        if ((financialData === null || financialData === void 0 ? void 0 : financialData.length) >= 1) {
            setFilteredFinancialData(financialData === null || financialData === void 0 ? void 0 : financialData.filter((item) => {
                var _a;
                return (item === null || item === void 0 ? void 0 : item.companyId) ===
                    ((_a = record === null || record === void 0 ? void 0 : record.companyId) !== null && _a !== void 0 ? _a : record === null || record === void 0 ? void 0 : record.trackedItemCompanyId);
            }));
        }
        // }
    }, [financialData, record]);
    const { pathname } = useLocation();
    const breadCrumbList = getBreadCrumbSession();
    const getBreadCrumbData = (ratingRecord) => {
        var _a, _b, _c, _d, _e, _f;
        const { categoryId, currentBand } = ratingRecord;
        const name = ratingRecord === null || ratingRecord === void 0 ? void 0 : ratingRecord.title;
        const parentPath = (_b = (_a = breadCrumbList === null || breadCrumbList === void 0 ? void 0 : breadCrumbList.at(-1)) === null || _a === void 0 ? void 0 : _a.parentPath) !== null && _b !== void 0 ? _b : ``;
        const isGroupLevel = (_d = (_c = record === null || record === void 0 ? void 0 : record.category) === null || _c === void 0 ? void 0 : _c.includes("Group")) !== null && _d !== void 0 ? _d : (_e = record === null || record === void 0 ? void 0 : record.hierarchy) === null || _e === void 0 ? void 0 : _e.includes("Group");
        //placeholder path for category page on dashboard
        const path = isGroupLevel ? `/0/0/${+categoryId}` : `/0/${+categoryId}`;
        return {
            path,
            name,
            key: ratingRecord === null || ratingRecord === void 0 ? void 0 : ratingRecord.categoryId,
            category: `Category Dashboard`,
            bandName: (record === null || record === void 0 ? void 0 : record.weight) !== 0 && !(record === null || record === void 0 ? void 0 : record.weightFlag)
                ? currentBand === null || currentBand === void 0 ? void 0 : currentBand.currentStatus
                : "E",
            bandColor: (record === null || record === void 0 ? void 0 : record.weight) === TrackedItemsVariables.UnrateableCode
                ? TrackedItemsVariables.UnrateableColor
                : ((_f = currentBand === null || currentBand === void 0 ? void 0 : currentBand.currentStatusRgb) !== null && _f !== void 0 ? _f : "lightgrey"),
            parentPath: `${parentPath}${path}`,
            subCategoryId: ratingRecord === null || ratingRecord === void 0 ? void 0 : ratingRecord.subCategoryId,
        };
    };
    const handleNavigateDashboard = (ratingRecord) => {
        const recordBreadCrumb = getBreadCrumbData(ratingRecord);
        if (!isEmpty(navigateCallBack)) {
            navigateCallBack(record, recordBreadCrumb);
            return;
        }
        setKey(BREADCRUMB, [...breadCrumbList, recordBreadCrumb], sessionStorage);
        // setKey(
        //   BREADCRUMB_PREVIOUS_PATH,
        //   [...breadCrumbList, recordBreadCrumb],
        //   sessionStorage
        // );
        if (SessionStorage.getKey(SessionVariables.EXPANDED_KEYS, sessionStorage) !==
            null) {
            const ids = getKey(BREADCRUMB, sessionStorage).map((item) => parseInt(item.key));
            setKey(SessionVariables.EXPANDED_KEYS, (ids === null || ids === void 0 ? void 0 : ids.length) > 0 ? ids : undefined, sessionStorage);
        }
        // console.log({ recordBreadCrumb, breadCrumbList });
        // setPrevBreadcrumbPath(breadCrumbList);
        history.push(`${pathname}${recordBreadCrumb === null || recordBreadCrumb === void 0 ? void 0 : recordBreadCrumb.path}`);
    };
    const iconStyles = {
        color: "#17A99A",
        marginRight: "10px",
    };
    // const isFinancialViewAllowed = isActionAllowed([
    //   REPORT_CATEGORY_CARE_FINANCIALS,
    // ]);
    // const isCareViewAllowed = isActionAllowed([
    //   REPORT_CATEGORY_CARE_DELIVERY,
    //   REPORT_CATEGORY_CARE_RISK,
    // ]);
    const hasCurrentRatingData = filteredFinancialData.some((item) => { var _a; return !isEmpty((_a = item === null || item === void 0 ? void 0 : item.currentBand) === null || _a === void 0 ? void 0 : _a.currentBandPercentage); });
    const contextJSX = (React.createElement("div", { className: "currentFinancialRatingBox " }, !filteredFinancialData.length ? (React.createElement("div", { className: `content-center-aligned bold-text no-data` }, "No Data")) : (React.createElement(React.Fragment, null,
        hasCurrentRatingData ? React.createElement("div", null, "Current Rating") : null, filteredFinancialData === null || filteredFinancialData === void 0 ? void 0 :
        filteredFinancialData.map((item) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (React.createElement(React.Fragment, null, !isEmpty((_a = item === null || item === void 0 ? void 0 : item.currentBand) === null || _a === void 0 ? void 0 : _a.currentBandPercentage) ? (React.createElement("div", { 
                // about="financial"
                className: "ratingRow rr-1 cursor-pointer", onClick: handleNavigateDashboard.bind({}, item) },
                React.createElement("div", { className: "rowTitle" },
                    React.createElement(RenderSvg, { icon: "Location", style: iconStyles }),
                    React.createElement("span", null, item === null || item === void 0 ? void 0 : item.title),
                    React.createElement(RenderSvg, { icon: (item === null || item === void 0 ? void 0 : item.hasWatchList)
                            ? "AddedToWatchlist"
                            : "WatchlistButton", tooltipTitle: localize(["Dashboard.addRemoveWatchlist"]), style: {
                            cursor: "pointer",
                            color: "#1B998F",
                            marginLeft: "1rem",
                        }, onClick: (event) => handleToggleModalVisibility(event, item === null || item === void 0 ? void 0 : item.itemId) })),
                filteredFinancialData === undefined ? (React.createElement(Skeleton.Button, { active: true, size: "default" })) : (React.createElement(RatingColumnComponent, { key: item.itemId, column: "current", decimals: item === null || item === void 0 ? void 0 : item.decimalPlaces, displayValue: item === null || item === void 0 ? void 0 : item.displayValue, valueType: item === null || item === void 0 ? void 0 : item.valueType, movingAverage: (_b = item === null || item === void 0 ? void 0 : item.currentBand) === null || _b === void 0 ? void 0 : _b.currentBandPercentage, statusRgb: (_c = item === null || item === void 0 ? void 0 : item.currentBand) === null || _c === void 0 ? void 0 : _c.currentStatusRgb, status: (_d = item === null || item === void 0 ? void 0 : item.currentBand) === null || _d === void 0 ? void 0 : _d.currentStatus, date: (_e = item === null || item === void 0 ? void 0 : item.currentBand) === null || _e === void 0 ? void 0 : _e.bandDateTime, weight: record === null || record === void 0 ? void 0 : record.weight, weightFlag: record === null || record === void 0 ? void 0 : record.weightFlag, statusMA: (_f = item === null || item === void 0 ? void 0 : item.currentBand) === null || _f === void 0 ? void 0 : _f.currentStatusMovingAverage, actualValue: (_g = item === null || item === void 0 ? void 0 : item.currentBand) === null || _g === void 0 ? void 0 : _g.currentActualValue, systemCreated: !(record === null || record === void 0 ? void 0 : record.isLeaf) || record.systemCreated, showFlag: false })))) : (React.createElement("div", { className: `content-center-aligned bold-text no-data` }, "No Data"))));
        })))));
    return (React.createElement("div", { className: "dottedActionsButton" },
        React.createElement(Button, { type: "primary", className: "dashed-action-btn" },
            React.createElement(Popover, { content: contextJSX, title: null, placement: "right", trigger: "click", visible: showFinancialRating, onVisibleChange: (isVisble) => {
                    if (!document.querySelector(".ant-modal-mask")) {
                        setShowFinancialRating(isVisble);
                    }
                }, overlayClassName: "category-popover-container" },
                React.createElement("div", { className: "category-container" },
                    React.createElement(RenderSvg, { icon: "MoreActions", style: {
                            marginTop: "-2.4px",
                        } })))),
        React.createElement(AddRemoveWatchListModal, { onAddRemoveWatchList: (itemId, status) => {
                setFilteredFinancialData((prev) => [...prev].map((record) => {
                    if ((record === null || record === void 0 ? void 0 : record.itemId) === itemId) {
                        record.hasWatchList = status;
                    }
                    return record;
                }));
            }, handleToggleModalVisibility: handleToggleModalVisibility, selectedTrackItemId: watchListModalData })));
};
export default CurrentFinancialRatingBox;
